var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgColorfulIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "colorful"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.41379 0C1.08069 0 0 1.08069 0 2.41379V39.5862C0 40.9193 1.08069 42 2.41379 42H39.5862C40.9193 42 42 40.9193 42 39.5862V2.41379C42 1.08069 40.9193 0 39.5862 0H2.41379ZM10.9763 24.8244C10.9763 25.3576 11.4086 25.7899 11.9418 25.7899H13.6827C14.2159 25.7899 14.6482 25.3576 14.6482 24.8244V10.4251C14.6482 9.89186 14.2159 9.45958 13.6827 9.45958H11.9418C11.4086 9.45958 10.9763 9.89186 10.9763 10.4251V24.8244ZM19.4691 32.3293C19.4691 32.8625 19.9013 33.2948 20.4346 33.2948H22.1754C22.7087 33.2948 23.141 32.8625 23.141 32.3293V10.4251C23.141 9.89186 22.7087 9.45958 22.1754 9.45958H20.4346C19.9013 9.45958 19.4691 9.89186 19.4691 10.4251V32.3293ZM28.9274 33.2948C28.3941 33.2948 27.9618 32.8625 27.9618 32.3293V16.5127C27.9618 15.9795 28.3941 15.5472 28.9274 15.5472H30.6682C31.2015 15.5472 31.6338 15.9795 31.6338 16.5127V32.3293C31.6338 32.8625 31.2015 33.2948 30.6682 33.2948H28.9274Z",
    fill: "url(#paint0_linear_7701_434)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7701_434",
    x1: 21,
    y1: 0,
    x2: 21,
    y2: 70,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4C94FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C94FF",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgColorfulIcon);
export default __webpack_public_path__ + "static/media/colorful-icon.52e3c54889e9ab366b9234c6adca90b8.svg";
export { ForwardRef as ReactComponent };